define('areas/informationrequest/service/sectionapimappings',["require", "exports"], function (require, exports) {
    "use strict";
    var SectionAPIMapping = (function () {
        function SectionAPIMapping() {
        }
        SectionAPIMapping.GetHMRCAPIType = function (sectionName) {
            if (sectionName == SectionAPIMapping.MASectionName)
                return "marriageAllowance";
            if (sectionName == SectionAPIMapping.NICSectionName)
                return "nic";
            if (sectionName = SectionAPIMapping.EmploymentSectionName)
                return "employment";
            if (sectionName = SectionAPIMapping.PensionsAnnuities)
                return "pensionsAnnuities";
        };
        SectionAPIMapping.MASectionName = "Marriage Allowance";
        SectionAPIMapping.NICSectionName = "National Insurance Contributions";
        SectionAPIMapping.EmploymentSectionName = "Employment Income";
        SectionAPIMapping.PensionsAnnuities = "Pensions, Annuities and Other State Benefits";
        return SectionAPIMapping;
    }());
    exports.SectionAPIMapping = SectionAPIMapping;
});

